import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@app/environment/environment';
import { Observable } from 'rxjs';

export interface FileData {
  uploadedFile: File;
  uploadedFileDescription: string;
  uploadedFileIsPublic: boolean;
  uploadedFileType: number;
}

@Injectable({
  providedIn: 'root',
})
export class UploadService {
  private readonly API_URL = environment.apiUrl + '/File';
  private readonly PROJECT_API_URL = environment.apiUrl + '/ProjectSetup';

  constructor(private http: HttpClient) {}

  public uploadFilesForProject(
    projectId: string,
    files: FileData[]
  ): Observable<any> {
    const formData = new FormData();

    files.forEach((file) => {
      formData.append('UploadedFiles', file.uploadedFile);
      formData.append(
        'UploadedFilesDescriptions',
        file.uploadedFileDescription
      );
      formData.append(
        'UploadedFilesPublic',
        file.uploadedFileIsPublic.toString()
      );
      formData.append('UploadedFilesTypes', file.uploadedFileType.toString());
    });

    return this.http.post(
      `${this.PROJECT_API_URL}/${projectId}/Files`,
      formData
    );
  }
}
